import { render } from "./MCampaignWrapper.vue?vue&type=template&id=1f8326dc&ts=true"
import script from "./MCampaignWrapper.vue?vue&type=script&lang=ts"
export * from "./MCampaignWrapper.vue?vue&type=script&lang=ts"

import "./MCampaignWrapper.vue?vue&type=style&index=0&id=1f8326dc&lang=scss"

import exportComponent from "/home/runner/work/campaign-widget/campaign-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__